// extracted by mini-css-extract-plugin
export default {"classes":"show-classes_classes__rKIua","subStat":"show-classes_subStat__WyspZ"};